import { Link } from "react-router-dom";

import type { InboxHandOver } from "../../../api/types";
import { Card, EmptyState, Pill } from "../../../ui";
import { useNow } from "../hooks";
import { ageWords, formatWhen } from "../model/time";

/** The SME's home: the hand-overs waiting for review, with the number of elements, how many are Unsure, and how long they have waited. */
export function HandOversWaiting({ handOvers }: { handOvers: readonly InboxHandOver[] }) {
  const now = useNow();
  const total = handOvers.reduce((sum, h) => sum + h.count, 0);
  const unsure = handOvers.reduce((sum, h) => sum + h.unsure, 0);
  return (
    <Card aria-labelledby="handovers-title" className="nv-handovers">
      <h2 id="handovers-title">Hand-overs waiting for you</h2>
      {handOvers.length === 0 ? (
        <EmptyState title="No hand-over is waiting" action={<Link to="/inbox">Open the SME inbox</Link>}>
          When an engineer sends a hand-over, it appears here with the number of elements and how many are Unsure.
        </EmptyState>
      ) : (
        <>
          <p>
            {handOvers.length === 1 ? "1 hand-over" : `${handOvers.length} hand-overs`}, {total === 1 ? "1 element" : `${total} elements`} to review
            {unsure > 0 && `, ${unsure} marked Unsure`}.
          </p>
          <ul className="nv-handovers__list">
            {handOvers.map((handOver) => (
              <li key={handOver.id} className="nv-handovers__item">
                <strong>{handOver.engineer.display}</strong> <span className="muted">sent {formatWhen(handOver.sent_at, now)}</span>
                <span className="nv-handovers__facts">
                  {" "}
                  {handOver.count === 1 ? "1 element" : `${handOver.count} elements`}
                  {handOver.unsure > 0 && (
                    <>
                      {" "}
                      <Pill>{handOver.unsure} Unsure</Pill>
                    </>
                  )}{" "}
                  <span className="muted">waiting for {ageWords(handOver.age_days)}</span>
                </span>
              </li>
            ))}
          </ul>
          <p>
            <Link className="button button--primary" to="/inbox">
              Open the SME inbox
            </Link>
          </p>
        </>
      )}
    </Card>
  );
}
